import { Ng5SliderModule } from 'ng5-slider';
import { NvButtonModule } from './../../../../../nvps-libraries/design/nv-button/nv-button.module';
import { NvPillButtonModule } from './../../../../../nvps-libraries/design/nv-pill-button/nv-pill-button.module';
import { NvPillModule } from './../../../../../nvps-libraries/design/nv-pill/nv-pill.module';
import { NvDropdownModule } from './../../../../../nvps-libraries/design/nv-dropdown/nv-dropdown.module';
import { MultiMenuFilter } from './pipes/mulit-menu-filter/multi-menu-filter.pipe';
import { SuperFilterPill } from './pipes/super-filter-pill/super-filter-pill.pipe';
import { SuperFilterComponent } from './super-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [SuperFilterComponent, SuperFilterPill, MultiMenuFilter],
  imports: [
    MatMenuModule,
    CommonModule,
    NvDropdownModule,
    NvPillModule,
    NvPillButtonModule,
    NvButtonModule,
    FormsModule,
    ReactiveFormsModule,
    Ng5SliderModule,
  ],
  providers: [SuperFilterPill, MultiMenuFilter],
  exports: [SuperFilterComponent],
})
export class SuperFilterModule {
  //
}
